"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateTurnMeterVfxStepArgs = void 0;
const uuid_1 = require("uuid");
class UpdateTurnMeterVfxStepArgs {
    constructor(actorId, percent) {
        this.actorId = actorId;
        this.percent = percent;
        this.__typeName = "UpdateTurnMeter";
        this.id = (0, uuid_1.v4)();
    }
}
exports.UpdateTurnMeterVfxStepArgs = UpdateTurnMeterVfxStepArgs;
